import { render, staticRenderFns } from "./WaiveDebtDialog.vue?vue&type=template&id=151327fa"
import script from "./WaiveDebtDialog.vue?vue&type=script&lang=js"
export * from "./WaiveDebtDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports